<!-- <template>
  <div>
    <div class="">
      <div class="banner">
        <div class="container">
          <div class="header-div">
            <h1 class="header-text">Help</h1>
            <img class="header-logo" src="../assets/images/logo.png" />
          </div>
        </div>
      </div>

      <div class="container header-content">
        <h1 class="welcome-text">Signup Video</h1>

        <div id="help" class="thankYou">
          <video id="videoPlayer" src="../assets/video/traning.mp4" controls muted></video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['autoplay'],
};
</script>

<style scoped lang="scss">
.banner {
  background: url("../assets/images/help/help_bg.png");
  height: 650px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto;
  display: flex;
  align-items: center;
  background-size: cover;

  h1 {
    color: white;
    font-size: 80px;
    text-align: center;
  }
}

.container {
  padding: 130px 0px;
  max-width: 1030px;
  margin: auto;
  // padding-left: 16px;
  // padding-right: 16px;
  .width-50 {
    width: 50%;
    @media screen and (max-width: 769px) {
      width: 100%;
    }
  }

  // align-items: center;
  .header-div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .header-text {
    color: #fff;
    font-size: 45px;
  }

  .header-logo {
    height: 180px;
    width: auto;
    margin-top: 100px;
  }

  @media screen and (max-width: 1070px) {
    padding: 100px 16px;
    max-width: 1030px;
    margin: auto;
  }
}
.header-content {
  display: flex;
  flex-direction: column;
  gap: 16px;

  h1 {
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    font-weight: 800;
    font-size: 35px;
    margin-bottom: 60px;

    @media screen and (max-width: 600px) {
        font-weight: 600;
        font-size: 32px;
        margin-bottom: 16px;
    }
  }

  .thankYou {
    margin: auto;
    max-width: 450px;
    overflow: hidden;
    border-radius: 1rem;

    img {
      width: 100%;
      height: auto;
    }
  }
}
</style> -->

<template>
  <div>
    <div class="">
      <div class="banner">
        <div class="container">
          <div class="header-div">
            <h1 class="header-text">Help</h1>
            <img class="header-logo" src="../assets/images/logo.png" />
          </div>
        </div>
      </div>
      <div class="container header-content">
        <div v-if="helpId" class="service-section">
          <nav style="--bs-breadcrumb-divider: '>'; display: flex; justify-content: center;" aria-label="breadcrumb">
            <ol class="breadcrumb mb-0">
              <li class="breadcrumb-item breadcrumb-page"><a href="/help">Help</a></li>
              <li class="breadcrumb-item active breadcrumb-page" aria-current="page"> {{ selectedService ?
                selectedService.title : 'Service' }}
              </li>
            </ol>
          </nav>

          <p class="service-dec">{{ selectedService ? selectedService.details : 'Service' }}</p>
        </div>
        <div v-else>
          <div class="d-flex justify-content-center align-items-center flex-column">
            <h2 class="help-title">Welcome to nestease Help</h2>
            <p class="help-dec">Click on each feature below to learn what’s included. At the end,
              we’ll walk you through how to sign up in the app.</p>

          </div>
          <div class="outdoor-service outdoor-service-web">
            <div class="outdoor-service-box container">
              <div class="outdoor-service-label">
                <span class="left"></span> OUTDOOR SERVICES <span class="right"></span>
              </div>
              <div class="outdoor-service-grid">
                <!-- First row: 3 cards -->
                <a v-for="(service, idx) in outdoorServices.slice(0, 7)" :key="service.title"
                  :href="`/help/service/${service.id}`" class="outdoor-service-card">
                  <div class="outdoor-service-icon-bg" :style="{ backgroundImage: `url(${service.icon})` }"></div>
                  <div>
                    <div class="outdoor-service-title">{{ service.title }}</div>
                    <div class="outdoor-service-desc">{{ service.desc }}</div>
                  </div>
                </a>

              </div>
              <button class="about-us-btn about-us-btn-green outdoor-btn">DOWNLOAD NOW!</button>

            </div>
          </div>
          <div class="indoor-service indoor-service-web">
            <div class="indoor-service-box">
              <div class="indoor-service-label">
                <span class="left"></span> INDOOR SERVICES <span class="right"></span>
              </div>
              <div class="indoor-service-grid">
                <div v-for="service in indoorServices.slice(0, 1)" :key="service.title" class="indoor-service-card">
                  <div class="indoor-service-icon-bg" :style="{ backgroundImage: `url(${service.icon})` }"></div>
                  <div>
                    <div class="indoor-service-title">{{ service.title }}</div>
                    <div class="indoor-service-desc">{{ service.desc }}</div>
                  </div>
                </div>
              </div>

            </div>
            <div class="indoor-bottom-note">
              <p>Looking for a service not listed here?</p>
              <button type="button" class="btn btn-light contact-us">Contact Us</button>
            </div>
          </div>
        </div>
        <h1 class="welcome-text">Signup Video</h1>

        <div id="help" class="thankYou">

          <video id="videoPlayer" src="../assets/video/trainingVideoNew5.mp4" :autoplay="autoplay" controls muted
            ref="videoPlayer"></video>
          <!-- <video id="videoPlayer" src="../assets/video/traning.mp4" controls muted></video> -->

        </div>

        <!-- <a class="contect-com" href="mailto:contactus@nestease.com" target="_blank">contactus@nestease.com</a> -->
      </div>
    </div>
    <div class="promo-banner-container">
      <div class="promo-banner">
        <div class="promo-content">
          <h1 class="promo-banner-title">10% Off All 2025 Lawn Mowing Services</h1>
          <p class="tagline">YOUR NEED. YOUR TIME. YOUR CHOICE</p>
          <p class="service-decs">Service just 2 clicks away</p>
          <p>Download the app now to lock in your discount.</p>
          <div class="app-buttons">
            <img src="../assets/images/apple-store-ligth.svg" alt="Download on App Store" />
            <img src="../assets/images/playstore-ligth.svg" alt="Get it on Google Play" />
          </div>
        </div>
        <div class="phone-mockup">
          <img src="../assets/images/splash-mockup.svg" alt="Phone Mockup" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['autoplay'],
  watch: {
    autoplay(newVal) {
      if (newVal) {
        this.scrollToVideoPlayer();
        this.playVideo();
      }
    },
  },
  data() {
    return {
      outdoorServices: [
        {
          id: 1,
          title: 'Lawn Mowing',
          desc: 'Available | Download App',
          icon: require('../assets/images/lawn-mowing.svg'),
          details:
            'Fully automated with instant pricing, real-time updates, and seamless payments. Includes professional mowing, trimming, edging, and blowing. Choose weekly, bi-weekly, every 3 or 4 weeks, or on-demand. Bagging is not included at this time. Edging is performed as needed, based on lawn condition and growth, and may not be included in every visit. You can pause or change your schedule anytime.',
        },
        {
          id: 2,
          title: 'Mulching',
          desc: 'Available | Contact Us',
          icon: require('../assets/images/mulching.svg'),
          details:
            'Add mulch to flower beds, around trees, or other areas to improve appearance and help soil retain moisture. We prep the beds, deliver mulch, and spread it evenly. We can also install fabric underneath to help reduce weed growth.',
        },
        {
          id: 3,
          title: 'Pruning & Bush Trimming – One Time',
          desc: 'Available | Contact Us',
          icon: require('../assets/images/pruning.svg'),
          details:
            'A one-time cleanup to prune and shape bushes and remove overgrowth. Ideal before events or for seasonal refresh.',
        },
        {
          id: 4,
          title: 'Pruning & Bush Trimming – Regular',
          desc: 'Available | Contact Us',
          icon: require('../assets/images/pruning.svg'),
          details:
            'Ongoing trimming to keep bushes healthy and clean-looking. Available as an add-on based on your lawn mowing schedule.',
        },
        {
          id: 5,
          title: 'Leaf Removal',
          desc: 'Coming This Fall',
          icon: require('../assets/images/leaf-removal.svg'),
          details:
            'Rakes and removes leaves from lawns and beds. Haul-away included. Ideal for heavy fall leaf buildup or regular maintenance.',
        },
        {
          id: 6,
          title: 'Aeration',
          desc: 'Coming This Fall',
          icon: require('../assets/images/aeration.svg'),
          details:
            'Perforates the soil to improve airflow, nutrient absorption, and root growth. Often paired with overseeding for best results.',
        },
        {
          id: 7,
          title: 'Overseeding',
          desc: 'Coming This Fall',
          icon: require('../assets/images/overseeding.svg'),
          details:
            'Applies grass seed to thicken lawns and fill in bare spots. Most effective when combined with aeration.',
        },
        {
          id: 8,
          title: 'Winterization',
          desc: 'Coming This Fall',
          icon: require('../assets/images/winterization.svg'),
          details:
            'Prepares your irrigation system for freezing weather by removing water from pipes to prevent damage.',
        },
        {
          id: 9,
          title: 'Yard Cleanup',
          desc: 'Available | Contact Us',
          icon: require('../assets/images/yard-cleanup.svg'),
          details:
            'Removal of fallen branches, debris, leaves, or overgrown brush. Perfect for seasonal cleanups or post-storm recovery.',
        },
        {
          id: 10,
          title: 'Gutter Cleaning',
          desc: 'Available | Contact Us',
          icon: require('../assets/images/gutter-clean.svg'),
          details:
            'Removal of leaves and debris from gutters to ensure proper drainage and prevent water damage. Includes full cleanup of gutter mess.',
        },
        {
          id: 11,
          title: 'Planting: Small Trees or Bushes',
          desc: 'Available | Contact Us',
          icon: require('../assets/images/planting.svg'),
          details:
            'We’ll plant small trees or shrubs you’ve purchased, or we can recommend and supply them. Includes digging, planting, and post-planting cleanup.',
        },
        {
          id: 12,
          title: 'Paver Installation',
          desc: 'Available | Contact Us',
          icon: require('../assets/images/paver-installation.svg'),
          details:
            'Install pavers for patios, walkways, or side areas — perfect for refreshing small to mid-sized outdoor spaces. Includes ground prep, leveling, and clean finish.',
        },
        {
          id: 13,
          title: 'Pressure Washing',
          desc: 'Available | Contact Us',
          icon: require('../assets/images/gutter-clean.svg'),
          details:
            'Washing uses high-powered water jets to remove dirt, grime, mold, and stains from outdoor surfaces like driveways, siding, and patios. It restores curb appeal and helps maintain your property’s cleanliness and longevity.',
        },
        {
          id: 14,
          title: 'Snow Removal',
          desc: 'Coming This Winter',
          icon: require('../assets/images/snow-removal.svg'),
          details:
            'Clears snow from driveways and walkways. Includes shoveling or plowing, depending on snow depth and area.',
        },
        {
          id: 15,
          title: 'Weed Control – Non Lawn',
          desc: 'Coming Soon',
          icon: require('../assets/images/weed-control.svg'),
          details:
            'Targets weeds in non-lawn areas like driveways, fence lines, and flower beds. Applied as needed during scheduled visits.',
        },
      ]

      ,
      indoorServices: [
        {
          title: 'House Cleaning',
          desc: 'Coming This Fall',
          icon: require('../assets/images/house-cleaning.svg'),
        },
        {
          title: 'Snow Removal',
          desc: 'Coming This Winter',
          icon: require('../assets/images/snow-removal.svg'),
        },
      ],

    };
  },
  methods: {
    // playVideo() {
    //   const video = this.$refs.videoPlayer;
    //   if (video) {
    //     video.play();
    //   }
    // },
    scrollToVideoPlayer() {
      const video = this.$refs.videoPlayer;
      if (video) {
        video.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },
  },
  mounted() {
    if (this.autoplay) {
      setTimeout(() => {
        this.scrollToVideoPlayer();

      }, [1000])
      // this.playVideo();
    }
  },
  computed: {
    helpId() {
      return this.$route.params.id || null;
    },
    selectedService() {
      return this.outdoorServices.find(service => service.id == this.helpId);
    }
  }
};
</script>

<style scoped lang="scss">
.breadcrumb-page {
  font-family: "Robot", sans-serif;
  font-weight: 800;
  font-size: 35.7px;
  text-align: center;
  vertical-align: middle;
  color: #000 !important;
  text-decoration: none !important;

  a {
    color: #000 !important;
    text-decoration: none !important;
    padding: 0 !important;
  }
}

.service-section {
  max-width: 990px;
  margin: auto;
  text-align: center;

}

.service-dec {
  font-family: "Robot", sans-serif;
  font-weight: 400;
  font-size: 28px;
  text-align: center;
  vertical-align: middle;
  color: #5D6970;
}

.banner {
  background: url("../assets/images/help/help_bg.png");
  height: 650px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto;
  display: flex;
  align-items: center;
  background-size: cover;

  h1 {
    color: white;
    font-size: 80px;
    text-align: center;
  }
}

.container {
  padding: 130px 0px;
  max-width: 1480px;
  margin: auto;

  // padding-left: 16px;
  // padding-right: 16px;
  .width-50 {
    width: 50%;

    @media screen and (max-width: 769px) {
      width: 100%;
    }
  }

  // align-items: center;
  .header-div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .header-text {
    color: #fff;
    font-size: 45px;
  }

  .header-logo {
    height: 180px;
    width: auto;
    margin-top: 100px;
  }

  @media screen and (max-width: 1070px) {
    padding: 100px 16px;
    max-width: 1030px;
    margin: auto;
  }
}

.header-content {
  display: flex;
  flex-direction: column;
  gap: 16px;

  h1 {
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    font-weight: 800;
    font-size: 35px;
    margin-bottom: 60px;

    @media screen and (max-width: 600px) {
      font-weight: 600;
      font-size: 32px;
      margin-bottom: 16px;
    }
  }

  .thankYou {
    margin: auto;
    max-width: 450px;
    overflow: hidden;
    border-radius: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;

    video {
      width: 100%;
      height: auto;
    }
  }
}

.help-title {
  font-family: 'Roboto', sans-serif;
  font-weight: 800;
  font-size: 35.7px;
  text-align: center;
  vertical-align: middle;
  color: #000000;
}

.help-dec {
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 28px;
  text-align: center;
  vertical-align: middle;
  color: #5D6970;
  width: 990px;

}

.outdoor-service {
  width: 100%;
  display: flex;
  justify-content: center;

  .outdoor-service-box {
    border: 1.5px solid #1fc688;
    border-radius: 16px;
    padding: 2.5rem 2rem 2.5rem 2rem;
    background: #fff;
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    box-sizing: border-box;
  }

  .outdoor-service-label {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.7rem;
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-size: 30px;
    line-height: line height/35;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;
    text-transform: uppercase;
    color: #000;
    padding-bottom: 2.5rem;

    .left {
      display: inline-block;
      width: 40px;
      height: 16px;
      background: url('../assets/images/about-label.svg') no-repeat center/contain;
    }

    .right {
      display: inline-block;
      width: 40px;
      height: 16px;
      background: url('../assets/images/right-label.svg') no-repeat center/contain;
    }
  }


  .outdoor-service-card {
    background: #F8F8F8;
    border-radius: 16px;
    padding: 24px;
    display: flex;
    align-items: center;
    min-height: 140px;
    position: relative;
    gap: 10px
  }

  .outdoor-service-icon-bg {
    width: 92px;
    height: 92px;
    border-radius: 18px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
    background-size: 48px 48px;
    background-repeat: no-repeat;
    background-position: center;
    margin-bottom: 0.7rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .outdoor-service-title {
    color: #222;
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-size: 30px;
    line-height: 100%;
    letter-spacing: 0%;
    vertical-align: middle;
    margin-bottom: 8px;
  }

  .outdoor-service-desc {
    color: #888;
    font-family: 'Roboto', sans-serifs;
    font-weight: 400;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0%;
    vertical-align: middle;
  }

  .outdoor-service-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, auto));
    gap: 2rem 2rem;
    margin-bottom: 2rem;

    a {
      text-decoration: none !important;
    }
  }

  .outdoor-btn {
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: fit-content;
  }


}

.about-us-btn-green {
  background: #1fc688;
  color: #fff;
}

.about-us-btn {
  font-size: 1.1rem;
  font-weight: 600;
  border: none;
  border-radius: 99px;
  padding: 20px 30px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  background: #1fc688;
  color: #fff;
}

.indoor-service {
  width: 100%;
  padding: 40px 0 0 0;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;

  .indoor-service-box {
    border: 1.5px solid #1fc688;
    border-radius: 16px;
    padding: 2.5rem 2rem 2.5rem 2rem;
    background: #fff;
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    box-sizing: border-box;
  }

  .indoor-service-label {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.7rem;
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-size: 30px;
    line-height: line height/35;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;
    text-transform: uppercase;
    color: #000;
    padding-bottom: 2.5rem;

    .left {
      display: inline-block;
      width: 40px;
      height: 16px;
      background: url('../assets/images/about-label.svg') no-repeat center/contain;
    }

    .right {
      display: inline-block;
      width: 40px;
      height: 16px;
      background: url('../assets/images/right-label.svg') no-repeat center/contain;
    }
  }

  .indoor-service-grid {
    display: grid;
    // grid-template-columns: repeat(2, 1fr);
    gap: 2rem 2rem;

    @media (max-width: 900px) {
      grid-template-columns: 1fr;
    }
  }

  .indoor-service-card {
    background: #fafbfc;
    border-radius: 16px;
    padding: 1.5rem 1.2rem 1.2rem 1.2rem;
    display: flex;
    align-items: center;
    min-width: 180px;
    min-height: 120px;
    position: relative;
    gap: 10px;
  }

  .indoor-service-icon-bg {
    width: 92px;
    height: 92px;
    border-radius: 18px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
    background-size: 48px 48px;
    background-repeat: no-repeat;
    background-position: center;
    margin-bottom: 0.7rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .indoor-service-title {
    color: #222;
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    line-height: 100%;
    letter-spacing: 0%;
    vertical-align: middle;
    margin-bottom: 8px;
  }

  .indoor-service-desc {
    color: #888;
    font-family: 'Roboto', sans-serifs;
    font-weight: 400;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0%;
    vertical-align: middle;
  }
}

.indoor-bottom-note {
  left: 50%;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 2.5rem;
  gap: 24px;
}

.indoor-bottom-note p {
  margin: 0 !important;
  font-size: 18px;
}

.indoor-bottom-note .contact-us {
  border-radius: 999px;
  padding-top: 20px;
  padding-right: 30px;
  padding-bottom: 20px;
  padding-left: 30px;
  gap: 10px;
  background-color: #DDDDDD;
  font-size: 24px;
  font-family: "Robot", sans-serif;
  font-weight: 600;
  text-transform: uppercase;
}

.promo-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px;
  border-radius: 16px;
  color: white;
  flex-wrap: wrap;
  position: relative;
  bottom: -200px;
  height: 550px;
  background-image: url("../assets/images/promo-banner.svg");
  background-repeat: no-repeat;
  background-size: cover;
}

.promo-content h1 {
  font-family: 'Roboto', sans-serif;
  font-weight: 800;
  font-size: 47px;
  letter-spacing: 0%;
  vertical-align: middle;
  margin-bottom: 20px;
}

.promo-content .service-decs {
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 24px;
  vertical-align: middle;
  margin-bottom: 20px;
}

.promo-content .tagline {
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 30px;
  vertical-align: middle;
  padding-bottom: 0;
}

.promo-content p {
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  vertical-align: middle;
}

.app-buttons {
  margin-top: 20px;
  display: flex;
  gap: 12px;
}

.app-buttons img {
  height: 40px;
  cursor: pointer;
}

.phone-mockup img {
  width: auto;
}

@media (min-width:300px) {
  .promo-banner-container {
    margin-top: 450px;
    margin-bottom: 100px;
  }
    .promo-wrapper {
    margin-top: 400px !important;
    margin-bottom: 100px !important;
    position: unset;
  }

  .container .phone-section {
    top: -300px;
    position: relative;
  }

.promo-content h1 {
    font-size: 20px;
  }

  .promo-banner {
    flex-direction: column-reverse;
    margin-left: 20px;
    margin-right: 20px;
    height: 550px;
    bottom:0;
  }


  .phone-mockup img {
    width: 300px;
    position: absolute;
    left: 50%;
    right: 50%;
    transform: translate(-50%, -80%);

  }
}

@media(min-width:768px) {

    .promo-banner {
        width: 1480px;
        margin-left: 40px;
        margin-right: 40px;
        bottom: -230px;
                padding: 20px;
        flex-direction: row;
    }
    .promo-banner-container {
        display: flex
;
        justify-content: center;
        width: 100%;
    }
  .promo-wrapper {
    margin-top: 600px !important;
    margin-bottom: 100px !important;
    position: unset;
  }

  .phone-mockup-container {
    position: relative;
    width: 441px;
    max-width: 100%;
    margin: 0 auto;
  }

  .promo-content {
    max-width: 400px;
    font-size: 20px;
  }

     .phone-mockup img {
        position: absolute;
        transform: none;
        width: 370px;
        bottom: 0;
    
}
  .promo-content h1 {
    font-size: 35px;
  }

  .promo-content .tagline {
    font-size: 20px;
  }

  .promo-content .service-decs {
    font-size: 20px;
  }

  .phone-mockup img {
    position: absolute;
    transform: none;
    width: 370px;
    bottom: 0;
  }
}

@media (min-width:992px) {
  .promo-wrapper {
    top: -150px !important;
    position: relative;
    margin: auto !important;
  }

  .phone-mockup-container {
    position: relative;
    width: 400px;
    max-width: 100%;
    margin: 0 auto;
  }

}

@media (min-width: 1200px) {
  .indoor-service {
    padding: 120px 16px 0px 16px;
  }

  .indoor-service .indoor-service-box {
    max-width: 100%;
  }

  .indoor-service .indoor-service-label {
    font-size: 30px;
  }

  .indoor-service-grid {
    grid-template-columns: repeat(1, 1fr);
  }

  .indoor-service .indoor-service-icon-bg {
    width: 92px;
    height: 92px;
  }

  .indoor-service .indoor-service-label {
    font-size: 30px;
  }

  .indoor-service-title {
    font-size: 30px;
  }

  .promo-banner-container {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 0;
  }

  .phone-mockup img {
    position: unset;
    transform: none;
    width: 440px;
  }

  .promo-content {
    max-width: 688px;
    font-size: 24px;
  }


  .promo-banner {
    width: 1480px;
    margin-left: 40px;
    margin-right: 40px;
    padding: 80px;
    flex-direction: row;
    bottom: -230px;

  }

  .promo-wrapper {
    top: 180px !important;
    position: relative !important;
  }


  .promo-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 2rem;
    position: relative;
    align-items: flex-start;
    height: 652px;
  }

  .phone-mockup-container {
    position: relative;
    width: 541px;
    max-width: 100%;
    margin: 0 auto;
  }

  .phone-mockup {
    position: absolute;
    bottom: 0;
    right: 150px;
  }
}

@media (min-width: 992px) and (max-width: 1338px) {

  .promo-content h1 {
    font-size: 40px;
  }

  .promo-content .tagline {
    font-size: 28px;
  }

  .promo-banner-container {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 0;
  }

  .promo-banner {
    width: 1200px;
    padding: 20px;
    flex-direction: row;
    bottom: -230px;
  }

  .phone-mockup-container {
    position: relative;
    width: 360px !important;
    max-width: 100%;
    margin: 0 auto;
  }

  .phone-mockup {
    right: 180px;
    position: absolute;
    bottom: 0;
    width: 350px;
  }

  .promo-content {
    max-width: 688px;
    font-size: 24px;
  }

  .app-buttons img {
    width: 236px;
    height: 70px;
  }
}

@media (min-width: 627px) and (max-width: 936.98px) {
  .promo-content h1 {
    font-size: 30px;
    max-width: 100%;
  }

  .promo-banner {
    flex-direction: column-reverse;
    margin-left: 20px;
    margin-right: 20px;
        bottom: 0;

  }

  .phone-mockup img {
    width: 350px;
    position: absolute;
    left: 50%;
    right: 50%;
    transform: translate(-50%, -80%);
  }

  .promo-banner-container {
    margin-top: 450px;
    margin-bottom: 100px;
  }
}
</style>
